import { applyMiddleware, compose, createStore } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import rootReducer from './reducers';
const middlewares = [thunk];
let composeEnhancers = compose;
if (process.env.NODE_ENV === 'development') {
	middlewares.push(logger);
	composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}
const store = createStore(
	rootReducer,
	composeEnhancers(applyMiddleware(...middlewares))
);
export default store;
